// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from Cut.module.scss  */
.Cut-module-HiddenText_vhd[aria-hidden='true'] {
  display: none; }

.Cut-module-EllipsisGradient_27l {
  position: absolute;
  display: inline-block;
  width: 80px;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, white 100%);
  transform: translate(-80px, 0); }
  .Cut-module-EllipsisGradient_27l::before {
    content: '\\A0'; }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Cut/Cut.css"],"names":[],"mappings":"AAAA,oCAAoC;AACpC;EACE,aAAa,EAAE;;AAEjB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,yEAAyE;EACzE,8BAA8B,EAAE;EAChC;IACE,cAAc,EAAE","sourcesContent":["/*  imported from Cut.module.scss  */\n.Cut-module-HiddenText_vhd[aria-hidden='true'] {\n  display: none; }\n\n.Cut-module-EllipsisGradient_27l {\n  position: absolute;\n  display: inline-block;\n  width: 80px;\n  background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, white 100%);\n  transform: translate(-80px, 0); }\n  .Cut-module-EllipsisGradient_27l::before {\n    content: '\\A0'; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
